import { useState, useEffect } from 'react';

import { GameScreen, Target } from './';

import { games } from '../Config/config';

const DEBUG = process.env.MIX_APP_ENV === 'local';

const LevelManager = ({ running, scale, increasePoints, game, level, handleGameShouldStop }) => {
    const [crossPosition, setCrossPosition] = useState(null);
    const [discovered, setDiscovered] = useState([]);
    const levelConfig = games[game][level];

    if (!levelConfig) {
        return null;
    }

    useEffect(() => {
        if (levelConfig.targets.length === discovered.length) {
            handleGameShouldStop();
        }
    }, [discovered]);

    const handleNonTargetClick = (e) => {
        let currentTargetRect = e.currentTarget.getBoundingClientRect();

        setCrossPosition([
            e.pageX - window.pageXOffset - currentTargetRect.left,
            e.pageY - window.pageYOffset - currentTargetRect.top
        ]);
    };

    const handleTargetClick = (target) => {
        if (running && discovered.indexOf(target.name) === -1) {
            increasePoints(target.points);
            
            setDiscovered([
                ...discovered,
                target.name,
            ]);

            setCrossPosition(null);
        }
    };

    return (
        <>
            <GameScreen
                image={levelConfig.image}
                handleNonTargetClick={handleNonTargetClick}
                crossPosition={crossPosition}
            />

            {levelConfig.targets.map(target => (
                <Target
                    key={target.name}
                    onClick={handleTargetClick}
                    debug={DEBUG}
                    bottom={scale * target.bottom}
                    left={scale * target.left}
                    popUpBottom={scale * target.popUpBottom}
                    popUpLeft={scale * target.popUpLeft}
                    target={target}
                    discovered={discovered.indexOf(target.name) !== -1}
                    running={running}
                />
            ))}
        </>
    );
};

export default LevelManager;
